export class GridSortSetting{    
    public field: string;
    public description: string;
    public dir?: 'asc' | 'desc';    
    public selectionOrderIndex: number;
    public selectedOrderIndex: number;
}